(function (window) {
  'use strict';

  var GIFT =
    '<path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>';
  var RX_ICON =
    '<circle cx="6.5" cy="14.5" r="3.5"/><circle cx="17.5" cy="14.5" r="3.5"/>' +
    '<path d="M10 14.5c0-1 .9-1.8 2-1.8s2 .8 2 1.8M3 11l2-4h3M21 11l-2-4h-3"/>';
  var CHEV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
  var SHIP_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M1 3h13v13H1zM14 8h4l3 3v5h-7z"/>' +
    '<circle cx="5.5" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/></svg>';

  var state = {
    cfg: null,
    root: null,
    foot: null,
    section: null,
    activeTab: 0,
    stackOpen: false,
    ledgerOpen: false,
    mysteryVariantId: null,
    boundRoot: null,
    boundFoot: null,
    cfgRaw: null,
    atcBusy: false,
    /* handle -> true for bogos-gift / _hide_quantity_box:true products.
       cart.js has no tags, so Liquid seeds these and /products/<handle>.js
       fills in lines added after page load (BOGOS adds its gift via AJAX). */
    giftHandles: {},
    hideQtyHandles: {},
    tagLookups: {},
    /* handle -> { exempt, large } for the add-on rules (see addonCartState).
       Liquid seeds it; /products/<handle>.js fills in lines added later. */
    caseTags: {},
    /* handle -> true for add-ons added from an "Also popular" card, which
       stays on the rail checked instead of dropping out from under the tap */
    railAdded: {}
  };

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function money(cents) {
    var n = Number(cents) || 0;
    var out;
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoneyOrigin === 'function') {
      out = Shopify.formatMoneyOrigin(String(n));
    } else {
      var d = n / 100;
      out = '$' + (Math.round(d) === d ? String(Math.round(d)) : d.toFixed(2));
    }
    /* whole dollars: $89.00 → $89 */
    return String(out == null ? '' : out).replace(/([.,])00(?!\d)/g, '');
  }

  var cartQueue = Promise.resolve();

  function enqueueCart(fn) {
    cartQueue = cartQueue.then(fn).catch(function (err) {
      console.error('[CDFilled] cart', err);
      track('cart_error', {
        error_action: (err && err.cdAction) || 'cart_update',
        error_message: String((err && err.message) || err || '').slice(0, 200)
      });
    });
    return cartQueue;
  }

  /* Analytics — see assets/cart-analytics.js. No-op if it isn't loaded. */
  function track(name, data) {
    if (typeof window.cdTrack === 'function') window.cdTrack(name, data);
  }

  function dollars(cents) {
    return Math.round(Number(cents) || 0) / 100;
  }

  /* data-cd-* fields read by cdTrack.productFields() on add buttons */
  function trackAttrs(title, priceCents, type) {
    return (
      ' data-cd-title="' +
      esc(title || '') +
      '" data-cd-price="' +
      dollars(priceCents) +
      '" data-cd-type="' +
      esc(type || '') +
      '"'
    );
  }

  function lineFields(c) {
    if (!c) return {};
    return {
      product_handle: c.handle || '',
      variant_id: String(c.variantId || ''),
      product_title: c.title || '',
      product_type: c.type || '',
      item_kind: c.kind || '',
      price: dollars(c.final != null ? c.final : c.original)
    };
  }

  /* Cart context merged into every analytics event */
  function analyticsContext() {
    if (!state.cfg || !state.cfg.cart) return null;
    var P = pricing();
    var addonQty = items().reduce(function (n, c) {
      return n + (c.kind === 'addon' ? c.qty || 0 : 0);
    }, 0);
    return {
      cart_value: dollars(P.total),
      cart_value_before_discounts: dollars(P.original),
      cart_item_count: Number(state.cfg.cart.itemCount) || 0,
      b1g2f_pairs: P.n,
      b1g2f_step: P.n ? P.rem || 3 : 0,
      b1g2f_sets_complete: P.sets,
      b1g2f_status: P.n === 0 ? 'none' : P.rem === 0 ? 'complete' : 'filling',
      rx_pairs: P.rxQty,
      mystery_pairs: P.mysteryQty,
      addon_items: addonQty
    };
  }

  /* cart_b1g2f_progress whenever the B1G2F pair count changes. The last
     count lives in sessionStorage so a page load alone never fires it. */
  function checkB1g2fProgress() {
    if (!state.cfg || !state.cfg.cart) return;
    var n = pricing().n;
    var prev = state.lastPairs;
    if (prev == null) {
      try {
        var stored = sessionStorage.getItem('cd_b1g2f_pairs');
        if (stored != null) prev = Number(stored);
      } catch (err) {}
    }
    state.lastPairs = n;
    try {
      sessionStorage.setItem('cd_b1g2f_pairs', String(n));
    } catch (err) {}
    if (prev == null || prev === n) return;
    var rem = n % 3;
    track('cart_b1g2f_progress', {
      pairs_before: prev,
      pairs_after: n,
      direction: n > prev ? 'up' : 'down',
      milestone: n > prev && n > 0 && rem === 0 ? 'set_complete' : n > prev && rem === 2 ? 'one_away' : ''
    });
  }

  function cartImg(raw) {
    if (!raw) return '';
    if (raw.image) return raw.image;
    var feat = raw.featured_image;
    if (!feat) return '';
    return feat.url || feat.src || '';
  }

  function frameForHandle(handle) {
    var lists = productTabs().map(function (t) {
      return t.products || [];
    });
    if (state.cfg && state.cfg.rx && state.cfg.rx.products) lists.push(state.cfg.rx.products);
    (state.cfg && state.cfg.addons ? state.cfg.addons : []).forEach(function (a) {
      if (a.products) lists.push(a.products);
    });
    var i;
    var j;
    for (i = 0; i < lists.length; i++) {
      for (j = 0; j < lists[i].length; j++) {
        if (lists[i][j].handle === handle) return lists[i][j].frame || '';
      }
    }
    return '';
  }

  function catalogProductByHandle(handle) {
    var lists = productTabs().map(function (t) {
      return t.products || [];
    });
    if (state.cfg && state.cfg.rx && state.cfg.rx.products) lists.push(state.cfg.rx.products);
    (state.cfg && state.cfg.addons ? state.cfg.addons : []).forEach(function (a) {
      if (a.products) lists.push(a.products);
    });
    var i;
    var j;
    for (i = 0; i < lists.length; i++) {
      for (j = 0; j < lists[i].length; j++) {
        if (lists[i][j].handle === handle) return lists[i][j];
      }
    }
    return null;
  }

  function isSafetyAccessory(raw) {
    var type = String(raw.product_type || raw.type || '').trim();
    var handle = String(raw.handle || '').toLowerCase();
    var title = String(raw.product_title || raw.title || '').toLowerCase();
    var tags = raw.tags;
    var tagStr = Array.isArray(tags) ? tags.join(',') : String(tags || '');
    if (type === 'Accessories' || type === 'Gift Crd' || type === 'Safety Accessories') return true;
    if (/_accessory_type:safety/i.test(tagStr)) return true;
    if (/side-?shield/.test(handle) || /side\s*shield/.test(title)) return true;
    if (/z87-safety-accessor/.test(handle)) return true;
    return false;
  }

  /* Match main cart-drawer BOGOF2 / nvn-is-b1g2f-pair:
     Sunglasses | Blue Light | Plain | Safety | -bl | -pl.
     Every Ophthalmic-typed product is prescription, whatever the variant. */
  function kindFromShopify(raw) {
    var type = String(raw.product_type || raw.type || '').trim();
    var handle = String(raw.handle || '');
    var mysteryHandle = state.cfg && state.cfg.mystery && state.cfg.mystery.handle;
    if (
      (mysteryHandle && handle === mysteryHandle) ||
      /mystery/i.test(type) ||
      /mystery/i.test(raw.product_title || raw.title || '')
    ) {
      return 'mystery';
    }
    if (type === 'Prescription' || type === 'Ophthalmic') return 'rx';
    if (isSafetyAccessory(raw)) return 'addon';
    if (type === 'Sunglasses' || type === 'Blue Light' || type === 'Plain' || type === 'Safety') return 'pair';
    if (handle.length >= 3) {
      var tail = handle.slice(-3).toLowerCase();
      if (tail === '-bl' || tail === '-pl') return 'pair';
    }
    return 'addon';
  }

  function rxEditUrl(raw) {
    var url = raw.url || '';
    if (!url) return '';
    var join = url.indexOf('?') >= 0 ? '&' : '?';
    url += join + 'edit=' + raw.variant_id + '&qty=' + raw.quantity;
    var props = raw.properties || {};
    if (props._prescription_type) url += '&type=' + encodeURIComponent(props._prescription_type);
    if (props._lens_color) url += '&lens=rx-lens-color-' + encodeURIComponent(props._lens_color);
    if (props._lens_upgrades) url += '&upgrades=' + encodeURIComponent(String(props._lens_upgrades).replace(/ \+ /g, ' , '));
    return url;
  }

  function readDiscounts(raw) {
    var out = [];
    var seen = {};
    function add(title, amount, value, valueType) {
      title = String(title || '').trim();
      amount = Number(amount) || 0;
      if (!title) return;
      var key = title.toLowerCase() + ':' + amount;
      if (seen[key]) return;
      seen[key] = true;
      out.push({ title: title, amount: amount, value: value, valueType: valueType });
    }
    (raw.discounts || []).forEach(function (d) {
      add(d.title, d.amount);
    });
    (raw.line_level_discount_allocations || []).forEach(function (a) {
      var app = a.discount_application || {};
      add(app.title, a.amount, app.value, app.value_type);
    });
    return out;
  }

  function prettyProp(val) {
    return String(val || '')
      .replace(/^rx-lens-color-/i, '')
      .replace(/^rx[-_]?/i, '')
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function propsFromRaw(raw) {
    var props = (raw && raw.properties) || {};
    return {
      prescriptionType: props._prescription_type || props['Prescription Type'] || '',
      lensColor: props._lens_color || props['Lens Color'] || ''
    };
  }

  function lensLabelFrom(item) {
    var type = prettyProp(item && (item.prescriptionType || item.prescription_type));
    var color = prettyProp(item && (item.lensColor || item.lens_color));
    var bits = [];
    if (type) bits.push(type);
    if (color) bits.push(color);
    return bits.join(' · ');
  }

  function hasTag(tags, tag) {
    return (Array.isArray(tags) ? tags : String(tags || '').split(',')).some(function (t) {
      return String(t).trim().toLowerCase() === tag;
    });
  }

  /* bogos-gift is what makes a line the BOGOS free gift (line 0, no
     qty / Remove). _hide_quantity_box:true on its own only hides qty / Remove. */
  function applyHideQty(c) {
    if (!c || !c.handle) return;
    if (state.giftHandles[c.handle]) {
      c.kind = 'gift';
      c.hideQty = true;
    } else if (state.hideQtyHandles[c.handle]) {
      c.hideQty = true;
    }
  }

  /* Look up tags for $0 lines Liquid never saw (e.g. a gift BOGOS just
     added), then repaint if one turns out to be a no-qty gift. */
  function lookupGiftTags(list) {
    list.forEach(function (c) {
      var handle = c.handle;
      if (!handle || state.giftHandles[handle] || state.hideQtyHandles[handle] || state.tagLookups[handle]) return;
      if ((Number(c.original) || 0) > 0) return;
      state.tagLookups[handle] = true;
      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (product) {
          if (!product) return;
          var gift = hasTag(product.tags, 'bogos-gift');
          var hide = hasTag(product.tags, '_hide_quantity_box:true');
          if (!gift && !hide) return;
          if (gift) state.giftHandles[handle] = true;
          if (hide) state.hideQtyHandles[handle] = true;
          items().forEach(applyHideQty);
          paint();
        })
        .catch(function () {});
    });
  }

  /* cart.js has no tags — look up the two the add-on rules read
     (_frame_name:23|cosmic, _product_case_size:large) for eyewear lines
     Liquid never saw, then repaint. */
  function lookupCaseTags(list) {
    list.forEach(function (c) {
      var handle = c.handle;
      if (!handle || c.kind === 'addon' || state.caseTags[handle]) return;
      state.caseTags[handle] = { exempt: false, large: false };
      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (product) {
          if (!product) return;
          var exempt = hasTag(product.tags, '_frame_name:23') || hasTag(product.tags, '_frame_name:cosmic');
          var large = !exempt && hasTag(product.tags, '_product_case_size:large');
          state.caseTags[handle] = { exempt: exempt, large: large };
          if (exempt || large) paint();
        })
        .catch(function () {});
    });
  }

  function mapShopifyItem(raw) {
    var kind = kindFromShopify(raw);
    var discounts = readDiscounts(raw);
    var props = propsFromRaw(raw);
    var catalog = catalogProductByHandle(raw.handle);
    var frame = (catalog && catalog.frame) || frameForHandle(raw.handle);
    var type = raw.product_type || raw.type || '';
    var vtitle = raw.variant_title || raw.variantTitle || raw.lens || '';
    return {
      key: raw.key,
      variantId: raw.variant_id || raw.variantId || raw.id,
      productId: raw.product_id || raw.productId,
      qty: raw.quantity != null ? raw.quantity : raw.qty,
      title: raw.product_title || raw.title,
      handle: raw.handle,
      img: cartImg(raw) || raw.img || '',
      kind: kind,
      type: type,
      frame: frame,
      z87: !!(
        (catalog && catalog.z87) ||
        type === 'Safety' ||
        /-z87\b/i.test(String(raw.handle || '')) ||
        /\bz87\b/i.test(String(raw.product_title || raw.title || ''))
      ),
      polarized: !!(catalog && catalog.polarized),
      uv400: !!(catalog && catalog.uv400),
      lens: vtitle,
      variantTitle: vtitle,
      prescriptionType: props.prescriptionType,
      lensColor: props.lensColor,
      lensLabel: lensLabelFrom(props),
      url: raw.url,
      editUrl: kind === 'rx' ? rxEditUrl(raw) : '',
      hideQty: false,
      inv: 0,
      final: raw.final_price != null ? raw.final_price : raw.discounted_price,
      original: raw.original_price != null ? raw.original_price : raw.price,
      lineFinal: raw.final_line_price != null ? raw.final_line_price : raw.line_price,
      lineOriginal: raw.original_line_price,
      discounts: discounts
    };
  }

  function applyShopifyCart(cart) {
    if (!state.cfg) state.cfg = {};
    var prevByKey = {};
    var prevByHandle = {};
    items().forEach(function (c) {
      if (c.key) prevByKey[c.key] = c;
      if (c.handle) prevByHandle[c.handle] = c;
    });
    var mapped = (cart.items || []).map(mapShopifyItem);
    mapped.forEach(function (c) {
      var prev = prevByKey[c.key] || prevByHandle[c.handle];
      if (!prev) return;
      /* cart.js has no product tags — keep Liquid frame / lens feature flags */
      if (!c.frame && prev.frame) c.frame = prev.frame;
      /* Prefer Liquid kind when cart.js remap collapses glasses → addon */
      if (c.kind === 'addon' && (prev.kind === 'pair' || prev.kind === 'readers' || prev.kind === 'rx')) {
        c.kind = prev.kind;
      }
      if (!c.type && prev.type) c.type = prev.type;
      if (!c.variantTitle && prev.variantTitle) {
        c.variantTitle = prev.variantTitle;
        c.lens = prev.lens || prev.variantTitle;
      }
      var catalog = catalogProductByHandle(c.handle);
      if (!catalog) {
        if (prev.polarized) c.polarized = true;
        if (prev.uv400) c.uv400 = true;
        if (prev.z87) c.z87 = true;
      } else if (catalog.z87) {
        c.z87 = true;
      }
      if (!c.prescriptionType && prev.prescriptionType) c.prescriptionType = prev.prescriptionType;
      if (!c.lensColor && prev.lensColor) c.lensColor = prev.lensColor;
      if (!c.lensLabel) c.lensLabel = lensLabelFrom(c) || prev.lensLabel || '';
      if (!c.editUrl && prev.editUrl) c.editUrl = prev.editUrl;
      if (c.handle && prev.kind === 'gift') state.giftHandles[c.handle] = true;
      if (c.handle && prev.hideQty) state.hideQtyHandles[c.handle] = true;
    });
    mapped.forEach(applyHideQty);
    lookupGiftTags(mapped);
    lookupCaseTags(mapped);
    var bogofCount = 0;
    var bogofLive = 0;
    mapped.forEach(function (c) {
      if (c.kind !== 'pair') return;
      bogofCount += c.qty || 0;
      bogofLive += c.lineFinal || 0;
    });
    state.cfg.cart = {
      itemCount: cart.item_count || 0,
      total: cart.total_price || 0,
      original: cart.original_total_price || 0,
      discount: cart.total_discount || 0,
      bogofCount: bogofCount,
      bogofLive: bogofLive,
      items: mapped
    };
  }

  function syncChrome(cart) {
    var n = cart && cart.item_count != null ? cart.item_count : 0;
    document.querySelectorAll('[data-cd-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
    document.querySelectorAll('[data-bind="itemCount"]').forEach(function (el) {
      el.innerHTML = n;
      el.style.display = n > 0 ? '' : 'none';
    });
    if (typeof update_collection_page_new_atcs === 'function') update_collection_page_new_atcs();
  }

  function reloadDrawerSection() {
    if (typeof update_cart_content === 'function') update_cart_content();
    if (typeof update_header_icon === 'function') update_header_icon();
  }

  function bumpLine(key, delta) {
    if (!key) return;
    if (!state.qtyIntent) state.qtyIntent = {};
    var line = null;
    items().some(function (c) {
      if (String(c.key) === String(key)) {
        line = c;
        return true;
      }
      return false;
    });
    var cur = state.qtyIntent[key] != null ? state.qtyIntent[key] : line ? line.qty : 0;
    changeLine(key, cur + Number(delta));
  }

  function syncCart(cart) {
    if (!cart) return;
    state.qtyIntent = {};
    if (!cart.item_count) {
      if (state.cfg) {
        state.cfg.cart = { itemCount: 0, total: 0, original: 0, discount: 0, bogofCount: 0, bogofLive: 0, items: [] };
        checkB1g2fProgress();
      }
      reloadDrawerSection();
      return;
    }
    applyShopifyCart(cart);
    syncChrome(cart);
    /* Keep stack open/closed as user left it while editing in-drawer */
    paint();
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('cart.js ' + res.status);
      return res.json();
    });
  }

  function refreshCart() {
    return enqueueCart(function () {
      return fetchCart().then(syncCart);
    });
  }

  function changeLine(key, quantity) {
    if (!key) return;
    var qty = Math.max(0, Number(quantity) || 0);
    if (!state.qtyIntent) state.qtyIntent = {};
    var line = null;
    items().some(function (c) {
      if (String(c.key) === String(key)) {
        line = c;
        return true;
      }
      return false;
    });
    var from = state.qtyIntent[key] != null ? state.qtyIntent[key] : line ? line.qty : 0;
    var fields = lineFields(line);
    state.qtyIntent[key] = qty;
    enqueueCart(function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok || (body && body.status && !body.items)) {
            var err = new Error((body && (body.description || body.message)) || 'change failed');
            err.cdAction = qty === 0 ? 'remove_item' : 'change_quantity';
            /* still sync so the drawer shows the real cart */
            fetchCart().then(syncCart).catch(function () {});
            throw err;
          }
          syncCart(body);
          if (qty === 0) {
            track('cart_item_removed', Object.assign({ quantity_removed: from }, fields));
          } else if (qty !== from) {
            track('cart_quantity_changed', Object.assign({ quantity_from: from, quantity_to: qty, quantity_delta: qty - from }, fields));
          }
        });
      });
    });
  }

  function items() {
    return (state.cfg && state.cfg.cart && state.cfg.cart.items) || [];
  }

  function units() {
    var u = [];
    items().forEach(function (c, i) {
      if (c.kind === 'pair') {
        for (var q = 0; q < c.qty; q++) u.push(i);
      }
    });
    return u;
  }

  function sumQty(kind) {
    return items().reduce(function (s, c) {
      return s + (c.kind === kind ? c.qty : 0);
    }, 0);
  }

  function pairCount() {
    return units().length + sumQty('mystery') + sumQty('rx') + sumQty('readers');
  }

  function listCents() {
    return (state.cfg.settings && state.cfg.settings.listCents) || 8900;
  }

  function chipHTML(tag, label) {
    if (tag === 'free') return '<span class="cd_chip cd_chip--free">' + esc(label || 'Free pair') + '</span>';
    if (tag === 'single') return '<span class="cd_chip cd_chip--off30">' + esc(label || '30% off') + '</span>';
    if (tag === 'named') {
      var named = String(label || '').trim();
      if (/30\s*%|30-off|30off/i.test(named)) {
        return '<span class="cd_chip cd_chip--off30">' + esc(named || '30% off') + '</span>';
      }
      return '<span class="cd_chip cd_chip--paid">' + esc(named || 'Your paid pair') + '</span>';
    }
    return '<span class="cd_chip cd_chip--paid">' + esc(label || 'Your paid pair') + '</span>';
  }

  function appliedDiscounts(c) {
    return ((c && c.discounts) || []).filter(function (d) {
      return d && Number(d.amount) > 0 && String(d.title || '').trim();
    });
  }

  function tagFromDiscountTitle(title) {
    var t = String(title || '').toLowerCase();
    if (/b1g2f|bogof|buy\s*1.*get\s*2/.test(t)) return 'free';
    if (/30-off|30\s*%|30off/.test(t)) return 'single';
    /* $25 / 4th-pair promo retired */
    if (/\$\s*25|\b25\b.*\b(extra|pair|bonus)|bonus\s*pair|fourth|4th/.test(t)) return 'paid';
    if (/free/.test(t)) return 'free';
    return 'named';
  }

  function chipLabel(tag, title, qty) {
    if (tag === 'free') return Number(qty) > 1 ? 'Free pairs' : 'Free pair';
    if (tag === 'single') return '30% off';
    return String(title || '').trim();
  }

  /* Badge from cart.js discount title where amount > 0. Price stays lineFinal. */
  function pairUnit(c) {
    var qty = Math.max(1, Number(c.qty) || 1);
    var lineFinal = Number(c.lineFinal);
    if (isNaN(lineFinal)) lineFinal = (Number(c.final) || 0) * qty;
    var final = Math.round(lineFinal / qty);
    var original = Number(c.original) || listCents();
    var applied = appliedDiscounts(c);
    var d = applied[0];
    var tag = 'paid';
    var title = '';
    if (d) {
      title = d.title;
      tag = tagFromDiscountTitle(title);
    } else if (final <= 0) {
      tag = 'free';
    }
    if (tag === 'bonus') tag = 'paid';
    return { tag: tag, label: chipLabel(tag, title), price: final, was: original };
  }

  function isZ87Pair(c) {
    if (!c) return false;
    if (c.z87) return true;
    var type = String(c.type || '').trim();
    var handle = String(c.handle || '').toLowerCase();
    var title = String(c.title || '').toLowerCase();
    return type === 'Safety' || /-z87\b/.test(handle) || /\bz87\b/.test(title);
  }

  function pairSubHTML(c) {
    var frame = customerFrame(c.frame);
    /* Don't treat catalog fallback "Polarized" as a frame name */
    if (/^polarized$/i.test(frame)) frame = '';
    if (/^z87\+?\s*safety$/i.test(frame)) frame = '';
    var type = String((c && c.type) || '').trim();
    var handle = String((c && c.handle) || '').toLowerCase();
    var title = String((c && c.title) || '').toLowerCase();
    var vtitle = String((c && (c.variantTitle || c.lens)) || '');
    var bits = [];
    if (frame) bits.push(esc(frame));

    var isBl = type === 'Blue Light' || /-bl$/.test(handle) || /Blue Light\s*\//.test(vtitle);
    var isPlain = type === 'Plain' || /-pl$/.test(handle) || /Plain\s*\//.test(vtitle);
    var isZ87 = isZ87Pair(c);
    var isClear =
      /\bclear\b/i.test(vtitle) ||
      /\bclear\b/i.test(String((c && c.title) || '')) ||
      isPlain;

    if (isBl) {
      bits.push('Blue Light');
      return bits.join(' · ') || 'Blue Light';
    }
    if (isZ87) {
      /* Chip carries Z87+ — sub is frame · Clear / lens only */
      if (isClear) bits.push('Clear');
      else if (/\bphotochromic\b/i.test(vtitle)) bits.push('Photochromic');
      else if (/\bpolarized\b/i.test(vtitle) || (c && c.polarized)) bits.push('Polarized');
      return bits.join(' · ') || (isClear ? 'Clear' : 'Z87+ Safety');
    }
    if (isPlain) {
      bits.push('Clear lenses');
      return bits.join(' · ') || 'Clear lenses';
    }
    /* Sunglasses: frame only — no Polarized / UV400 */
    return bits.join(' · ');
  }

  function readersSubHTML(c) {
    var frame = customerFrame(c.frame);
    if (/^polarized$/i.test(frame)) frame = '';
    if (/^z87\+?\s*safety$/i.test(frame)) frame = '';
    var bits = [];
    if (frame) bits.push(esc(frame));
    String((c && (c.variantTitle || c.lens)) || '')
      .split(/\s*\/\s*/)
      .forEach(function (part) {
        part = String(part || '').trim();
        if (!part || /^standard$/i.test(part)) return;
        bits.push(esc(part));
      });
    return bits.join(' · ') || 'Readers';
  }

  /* Display order ≠ Shopify /cart.js order.
     Paid trio pair → free B1G2F → 30% extras → mystery → addons → Rx last. */
  function tagRank(tag) {
    if (tag === 'free') return 1;
    if (tag === 'single' || tag === 'named') return 2;
    return 0;
  }

  function kindRank(kind) {
    if (kind === 'gift') return -1;
    if (kind === 'pair' || kind === 'readers') return 0;
    if (kind === 'mystery') return 1;
    if (kind === 'addon') return 2;
    if (kind === 'rx') return 3;
    return 4;
  }

  function displayItems() {
    return items()
      .map(function (c, i) {
        var tag = '';
        if (c.kind === 'pair') tag = pairUnit(c).tag;
        else if (c.kind === 'readers') tag = 'single';
        return {
          c: c,
          i: i,
          kind: c.kind,
          tag: tag
        };
      })
      .sort(function (a, b) {
        var kr = kindRank(a.kind) - kindRank(b.kind);
        if (kr) return kr;
        if (a.kind === 'pair' || a.kind === 'readers') {
          var tr = tagRank(a.tag) - tagRank(b.tag);
          if (tr) return tr;
        }
        return a.i - b.i;
      })
      .map(function (x) {
        return x.c;
      });
  }

  /* Stack thumbnails follow their own fixed category order, independent of
     the paid/free display order above: Sunglasses, Blue Light, Plain, Z87,
     Mystery, Prescription, Accessories. */
  function stackCategoryRank(c) {
    if (c.kind === 'gift') return -1;
    if (c.kind === 'pair') {
      if (isZ87Pair(c)) return 3;
      var type = String(c.type || '').trim();
      var handle = String(c.handle || '').toLowerCase();
      var vtitle = String(c.variantTitle || c.lens || '');
      var isBl = type === 'Blue Light' || /-bl$/.test(handle) || /Blue Light\s*\//.test(vtitle);
      var isPlain = type === 'Plain' || /-pl$/.test(handle) || /Plain\s*\//.test(vtitle);
      if (isBl) return 1;
      if (isPlain) return 2;
      return 0;
    }
    if (c.kind === 'readers') return 4;
    if (c.kind === 'mystery') return 5;
    if (c.kind === 'rx') return 6;
    if (c.kind === 'addon') return 7;
    return 8;
  }

  function countPairTags() {
    var freeCount = 0;
    var bonusCount = 0;
    var singleCount = 0;
    var freeSaving = 0;
    var singleSaving = 0;
    var rxSaving = 0;
    items().forEach(function (c) {
      if (c.kind === 'rx') {
        var rxDisc = 0;
        appliedDiscounts(c).forEach(function (d) {
          rxDisc += Number(d.amount) || 0;
        });
        if (rxDisc <= 0) {
          rxDisc = Math.max(0, (Number(c.lineOriginal) || 0) - (Number(c.lineFinal) || 0));
        }
        rxSaving += rxDisc;
        return;
      }
      if (c.kind === 'readers') {
        singleCount += c.qty || 0;
        var rDisc = 0;
        appliedDiscounts(c).forEach(function (d) {
          rDisc += Number(d.amount) || 0;
        });
        if (rDisc <= 0) {
          rDisc = Math.max(0, (Number(c.lineOriginal) || 0) - (Number(c.lineFinal) || 0));
        }
        singleSaving += rDisc;
        return;
      }
      if (c.kind !== 'pair') return;
      var u = pairUnit(c);
      var q;
      for (q = 0; q < (c.qty || 0); q++) {
        if (u.tag === 'free') freeCount++;
        else if (u.tag === 'single' || u.tag === 'named') singleCount++;
      }
      var lineDisc = 0;
      appliedDiscounts(c).forEach(function (d) {
        lineDisc += Number(d.amount) || 0;
      });
      if (lineDisc <= 0) {
        lineDisc = Math.max(0, (Number(c.lineOriginal) || 0) - (Number(c.lineFinal) || 0));
      }
      if (u.tag === 'free') freeSaving += lineDisc;
      else if (u.tag === 'single' || u.tag === 'named') singleSaving += lineDisc;
    });
    return {
      freeCount: freeCount,
      bonusCount: bonusCount,
      singleCount: singleCount,
      freeSaving: freeSaving,
      singleSaving: singleSaving,
      rxSaving: rxSaving
    };
  }

  function storyEach(n) {
    var s = (state.cfg && state.cfg.settings) || {};
    var trio = s.trioCents || 8900;
    var list = listCents();
    if (n <= 0) return 0;
    if (n <= 2) return Math.round(list * 0.7);
    if (n === 3) return Math.round(trio / 3);
    return Math.round((trio + Math.max(0, n - 3) * list) / n);
  }

  function eligibleN() {
    var cart = (state.cfg && state.cfg.cart) || {};
    var n = Number(cart.bogofCount);
    if (n > 0 || cart.bogofCount === 0) return n;
    return units().length;
  }

  /* Live total + list-price ceiling of just the leftover (currently 30%-off)
     pairs in the set that is still filling — whichever set that is. */
  function fillingSetTotals() {
    var live = 0;
    var maxList = 0;
    items().forEach(function (c) {
      if (c.kind !== 'pair') return;
      var u = pairUnit(c);
      if (u.tag !== 'single' && u.tag !== 'named') return;
      var qty = c.qty || 0;
      live += u.price * qty;
      if (u.was > maxList) maxList = u.was;
    });
    return { live: live, maxList: maxList };
  }

  function pricing() {
    var n = eligibleN();
    var rem = n % 3;
    var sets = Math.floor(n / 3);
    var tags = countPairTags();
    var rxQty = sumQty('rx');
    var mysteryQty = sumQty('mystery');
    var readersQty = sumQty('readers');
    var cart = state.cfg.cart || {};
    var glasses = glassesTotals();
    var pairsOnly = pairsOnlyTotals();
    var trioPrice = maxPairListCents();
    /* Drop amount for whichever set is 2/3 full (n = 3k+2) — the live total of
       its two 30%-off pairs minus what the completed set will cost. */
    var dropsAt3 = 0;
    if (rem === 2) {
      var filling3 = fillingSetTotals();
      if (filling3.live > filling3.maxList) {
        dropsAt3 = filling3.live - filling3.maxList;
      }
    }
    var rxOnly = n === 0 && rxQty > 0 && readersQty === 0;
    var freeSaving = tags.freeSaving || 0;
    var singleSaving = tags.singleSaving || 0;
    var pairSaving = freeSaving + singleSaving;
    /* v6: filling = leftover in an open set; complete = every pair in a finished trio */
    var filling = rem > 0;
    var complete = n >= 3 && rem === 0;
    var unlocked = n === 3;
    return {
      n: n,
      rem: rem,
      sets: sets,
      extra: Math.max(0, n - 3),
      freeCount: tags.freeCount,
      bonusCount: 0,
      singleCount: tags.singleCount,
      freeSaving: freeSaving,
      singleSaving: singleSaving,
      pairSaving: pairSaving,
      rxSaving: tags.rxSaving || 0,
      bonusSaving: 0,
      rxQty: rxQty,
      mysteryQty: mysteryQty,
      readersQty: readersQty,
      giftQty: sumQty('gift'),
      rxOnly: rxOnly,
      filling: filling,
      unlocked: unlocked && !rxOnly,
      stacking: false,
      complete: complete,
      showFreePicker: rem === 2,
      showBonus: false,
      showBonusOffer: false,
      showNextPicker: rem === 1,
      dropsAt3: dropsAt3,
      trioPrice: trioPrice,
      trioIfDone: trioPrice,
      setsTotal: sets * trioPrice,
      perPair: glasses.per,
      glassesQty: glasses.qty,
      pairEach: pairsOnly.per,
      addonCost: addonCostCents(),
      mysteryCost: mysteryCostCents(),
      extrasOriginal: extrasOriginalCents(),
      itemCount: cart.itemCount || 0,
      total: cart.total || 0,
      original: cart.original || 0,
      discount: cart.discount || 0
    };
  }

  function isGlassesLine(c) {
    var t = String((c && c.type) || '')
      .trim()
      .toLowerCase();
    return t === 'sunglasses' || t === 'blue light' || t === 'plain' || t === 'safety';
  }

  function glassesTotals() {
    var qty = 0;
    var sum = 0;
    items().forEach(function (c) {
      if (!isGlassesLine(c)) return;
      qty += c.qty || 0;
      sum += c.lineFinal || 0;
    });
    return { qty: qty, sum: sum, per: qty ? Math.round(sum / qty) : 0 };
  }

  /* B1G2F pairs only — no Mystery, no Rx, no add-ons. Feeds the progress-rail
     "N pairs — $X each" headline, which must average only the pairs it's
     counting (P.n). glassesTotals()/P.perPair also blends in Mystery Pair
     for the footer's per-pair line, which is deliberately broader. */
  function pairsOnlyTotals() {
    var qty = 0;
    var sum = 0;
    items().forEach(function (c) {
      if (c.kind !== 'pair') return;
      qty += c.qty || 0;
      sum += c.lineFinal || 0;
    });
    return { qty: qty, sum: sum, per: qty ? Math.round(sum / qty) : 0 };
  }

  function addonCostCents() {
    var sum = 0;
    items().forEach(function (c) {
      if (c.kind === 'addon') sum += Number(c.lineFinal) || 0;
    });
    return sum;
  }

  /* Original (pre-discount) price of every add-on + Mystery Pair line.
     Subtracted from cart.original so the displayed Subtotal only covers
     pairs/Rx — the same base the savings rows below it are computed
     against. Add-ons/Mystery are added back once, via the Add-ons row. */
  function extrasOriginalCents() {
    var sum = 0;
    items().forEach(function (c) {
      if (c.kind === 'addon' || c.kind === 'mystery') sum += Number(c.lineOriginal) || 0;
    });
    return sum;
  }

  function mysteryCostCents() {
    var sum = 0;
    items().forEach(function (c) {
      if (c.kind === 'mystery') sum += Number(c.lineFinal) || 0;
    });
    return sum;
  }

  /* B1G2F trio prices at the highest list price among current pairs (min $89) */
  function maxPairListCents() {
    var max = listCents();
    items().forEach(function (c) {
      if (c.kind !== 'pair') return;
      var unit = Number(c.original) || 0;
      if (unit > max) max = unit;
    });
    return max;
  }

  function handlesInCart() {
    var set = {};
    items().forEach(function (c) {
      if (c.handle) set[c.handle] = true;
    });
    return set;
  }

  function productTabs() {
    return (state.cfg && state.cfg.tabs) || [];
  }

  function tabsHTML(active, attr) {
    return productTabs()
      .map(function (t, i) {
        return (
          '<button type="button" role="tab" class="cd_empty_tab" aria-selected="' +
          (i === active) +
          '" data-' +
          attr +
          '="' +
          i +
          '"' +
          (t.viewAll ? ' data-view-all="' + esc(t.viewAll) + '"' : '') +
          '>' +
          esc(t.label) +
          '</button>'
        );
      })
      .join('');
  }

  function cardHTML(p, i, ctx, noLink) {
    var flag = '';
    var priceHTML = money(p.price);
    var addClass = '';
    var list = Number(p.compare || p.price) || 0;
    if (ctx === 'free') {
      flag = '<span class="cd_empty_card__flag cd_flag--gold">Free</span>';
      priceHTML = '<span class="cd_price--gold">$0</span> <s>' + money(list) + '</s>';
      addClass = '';
    } else if (ctx === 'single') {
      flag = '<span class="cd_empty_card__flag cd_flag--gold">30% off</span>';
      priceHTML =
        '<span class="cd_price--gold">' +
        money(Math.round((p.price || 0) * 0.7)) +
        '</span> <s>' +
        money(list) +
        '</s>';
    } else if (ctx === 'rx') {
      flag = '<span class="cd_empty_card__flag cd_flag--rx">30% off</span>';
      var rxEach = Math.round((p.price || 0) * 0.7);
      priceHTML = '<span class="cd_price--rx">' + money(rxEach) + '</span> <s>' + money(list) + '</s>';
      addClass = ' cd_add--rx';
    } else if (i === 0 && state.activeTab === 0) {
      flag = '<span class="cd_empty_card__flag">#1</span>';
    }
    return (
      '<div class="cd_empty_card cd_rail_card' +
      (flag ? ' hasflag' : '') +
      '">' +
      flag +
      '<div class="cd_empty_card__name">' +
      esc(p.title) +
      '</div><div class="cd_empty_card__sub">' +
      (function () {
        var fr = customerFrame(p.frame);
        if (fr) return esc(fr) + (ctx === 'rx' ? ' · Rx' : '');
        if (ctx === 'rx') return 'Rx';
        if (p.polarized) return 'Polarized';
        if (p.type === 'Blue Light') return 'Blue Light';
        if (p.type === 'Plain') return 'Clear lenses';
        if (p.z87 || p.type === 'Safety') return 'Z87+ Safety';
        return esc(p.blurb || p.type || '');
      })() +
      '</div>' +
      /* No product-page link on any rail card — tapping the card adds it */
      '<div class="cd_empty_card__shot" aria-hidden="true">' +
      (p.img ? '<img loading="lazy" src="' + esc(p.img) + '" alt="">' : '') +
      '</div>' +
      '<div class="cd_empty_card__foot"><div class="cd_empty_card__price">' +
      priceHTML +
      '</div>' +
      '<button type="button" class="cd_empty_card__add' +
      addClass +
      '" aria-label="Add ' +
      esc(p.title) +
      '" data-cd-atc data-variant-id="' +
      esc(p.variantId) +
      '" data-handle="' +
      esc(p.handle) +
      '"' +
      trackAttrs(p.title, p.price, p.type) +
      '>+</button></div></div>'
    );
  }

  function railHTML(list, ctx, limit, noLink, backfill) {
    var inCart = handlesInCart();
    var max = limit || 8;
    var seen = {};
    var picked = [];
    function take(src) {
      (src || []).forEach(function (p) {
        if (picked.length >= max || !p || seen[p.handle] || inCart[p.handle]) return;
        seen[p.handle] = true;
        picked.push(p);
      });
    }
    take(list);
    /* Pair rails never run dry: once the customer has carted most of this
       tab, top up from the other tabs, and as a last resort show the tab
       as-is (adding a pair already in the cart just bumps its quantity). */
    (backfill || []).forEach(take);
    if (!picked.length && backfill) picked = (list || []).slice(0, max);
    var cards = picked
      .map(function (p, i) {
        return cardHTML(p, i, ctx, noLink);
      })
      .join('');
    if (!cards) {
      return '<p class="cd_empty_grid__hint">Nothing left in this list.</p>';
    }
    return '<div class="cd_railwrap"><div class="cd_rail">' + cards + '</div></div>';
  }

  function tabRail(tabIndex, ctx, limit, noLink) {
    var tabs = productTabs();
    var tab = tabs[tabIndex] || tabs[0] || { products: [] };
    var others = tabs
      .filter(function (t) {
        return t !== tab;
      })
      .map(function (t) {
        return t.products;
      });
    return railHTML(tab.products, ctx, limit, noLink, others);
  }

  function addToCart(btn) {
    /* Silently ignore taps on any other add button while one add-to-cart
       call is still in flight — no UI change, just don't start a second
       request until the first resolves or rejects. */
    if (state.atcBusy) return;
    var variantId = btn.getAttribute('data-variant-id');
    var handle = btn.getAttribute('data-handle') || '';
    if (btn.hasAttribute('data-cd-mystery-add') && state.mysteryVariantId) {
      variantId = String(state.mysteryVariantId);
      try {
        sessionStorage.setItem('cd_mystery_vid', variantId);
      } catch (err) {}
    }
    if (!variantId || btn.disabled) return;
    state.atcBusy = true;
    btn.disabled = true;
    btn.classList.add('is-done');
    var fields = window.cdTrack && window.cdTrack.productFields ? window.cdTrack.productFields(btn) : {};
    fields.variant_id = String(variantId);
    track('cart_upsell_clicked', fields);
    var zone = btn.closest('[data-cd-offer], [data-cd-addons]');
    if (zone) zone.__cdHtml = null;
    if (btn.closest('.cd_acard')) state.railAdded[handle] = true;
    enqueueCart(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        /* "Add all" carries several variant ids, comma-separated */
        body: JSON.stringify({
          items: String(variantId)
            .split(',')
            .map(function (id, i) {
              return {
                id: Number(id),
                quantity: 1,
                properties: { _atc_source: 'filled-cart:' + (handle.split(',')[i] || handle) }
              };
            })
        })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok || body.status) {
              var err = new Error((body && (body.description || body.message)) || 'add failed');
              err.cdAction = 'add_upsell';
              throw err;
            }
            return fetchCart();
          });
        })
        .then(syncCart)
        .then(function () {
          state.atcBusy = false;
          track('cart_upsell_added', fields);
        })
        .catch(function (err) {
          state.atcBusy = false;
          btn.disabled = false;
          btn.classList.remove('is-done');
          throw err;
        });
    });
  }

  function changeQty(key, qty) {
    changeLine(key, qty);
  }

  function paintProgress(P) {
    var prog = qs('[data-cd-prog]', state.root);
    if (!prog) return;
    var s = state.cfg.settings || {};
    /* v6: finished sets = gold unlocked. No purple $25 stacking wash. */
    prog.classList.toggle('is-unlocked', P.complete && !P.rxOnly);
    prog.classList.toggle('is-bonus', false);
    prog.classList.toggle('is-stacking', false);
    prog.classList.toggle('is-rx', P.rxOnly);

    var icon = qs('[data-cd-prog-icon]', prog);
    if (icon) icon.innerHTML = P.rxOnly ? RX_ICON : GIFT;

    var title = qs('[data-cd-prog-title]', prog);
    var val = qs('[data-cd-prog-val]', prog);
    var sub = qs('[data-cd-prog-sub]', prog);
    var pips = qs('[data-cd-pips]', prog);

    if (P.rxOnly) {
      if (pips) pips.innerHTML = '';
      if (title) title.innerHTML = 'Prescription &mdash; 30% off';
      if (val) {
        val.classList.remove('is-bonus');
        val.textContent = P.rxQty + ' Rx pair' + (P.rxQty === 1 ? '' : 's');
      }
      if (sub) {
        sub.innerHTML =
          'Taken off every Rx pair, lenses included. <b>You save ' +
          money(P.rxSaving || P.discount) +
          '.</b><br>' +
          esc(s.offerTitle || 'Buy 1, Get 2 Free') +
          ' is a separate offer on non-prescription sunglasses.';
      }
      return;
    }

    /* Bar tracks the set that is filling; a finished set shows full and gold */
    var filled = P.rem === 0 ? 3 : P.rem;
    var pipHtml = '';
    for (var i = 0; i < 3; i++) {
      var on = i < filled;
      var pulse = !on && i === filled && P.filling ? ' is-pulse' : '';
      pipHtml +=
        '<div class="cd_pip' +
        (on ? ' is-on' : '') +
        pulse +
        '"><div class="cd_pip__fill"></div></div>';
    }
    if (pips) pips.innerHTML = pipHtml;

    var trioMoney = money(P.trioPrice || listCents());
    var trioEach = money(Math.round((P.trioPrice || listCents()) / 3));
    var trioIfDone = money(P.trioIfDone || P.trioPrice || listCents());
    var rxNote = P.rxQty
      ? ' Rx pair' + (P.rxQty === 1 ? ' is' : 's are') + ' priced separately at 30% off.'
      : '';
    var each = money(P.pairEach || storyEach(P.n));
    var setWord = P.sets === 1 ? 'set' : 'sets';
    var t;
    var v;
    var su;

    if (P.n === 0) {
      t = 'Add a pair &mdash; two more come free';
      v = '0 of 3';
      su = 'Mystery Pairs sit outside the offer. Add a pair and the next two are <b>free</b>.';
    } else if (P.n === 1) {
      t = '30% off applied';
      v = '1 of 3';
      su =
        'Add 2 more pairs and they&rsquo;re <b>free</b> &mdash; <b>3 pairs for ' +
        trioIfDone +
        '</b>, <span class="cd_pct">' +
        money(Math.round((P.trioIfDone || P.trioPrice || listCents()) / 3)) +
        ' each</span>.' +
        ((P.trioIfDone || P.trioPrice || listCents()) > listCents()
          ? ' You only pay for your highest-priced pair.'
          : '');
    } else if (P.n === 2) {
      t = 'Add 1 more and your total <span class="cd_pct">drops</span>';
      v = '2 of 3';
      su =
        'Three pairs cost <b>' +
        trioIfDone +
        '</b> &mdash; <span class="cd_pct">' +
        money(P.dropsAt3) +
        ' less than the two you have</span>.';
    } else if (P.n === 3) {
      t = esc(s.offerTitle || 'Buy 1, Get 2 Free') + '&trade; unlocked';
      v = '3 of 3';
      su =
        '<b>3 pairs, ' +
        trioMoney +
        '</b> &mdash; ' +
        trioEach +
        ' each.' +
        (P.rxQty ? rxNote : ' Add another and start your next set.');
    } else {
      t = P.n + ' pairs &mdash; ' + each + ' each';
      v = '';
      if (P.rem === 0) {
        su =
          '<b>' +
          P.sets +
          ' ' +
          setWord +
          ' of ' +
          esc(s.offerTitle || 'Buy 1, Get 2 Free') +
          '&trade;.</b> <span class="cd_pct">You saved ' +
          money(P.pairSaving || 0) +
          '</span> off list price.' +
          rxNote;
      } else if (P.rem === 2) {
        su = P.dropsAt3
          ? 'Add 1 more and your total <span class="cd_pct">drops ' +
            money(P.dropsAt3) +
            '</span> &mdash; pair ' +
            (P.n + 1) +
            ' is free.' +
            rxNote
          : 'Add 1 more &mdash; pair ' + (P.n + 1) + ' is <b>free</b>.' + rxNote;
      } else {
        su =
          'Add 2 more and they&rsquo;re <b>free</b> &mdash; your next 3 pairs for <b>' +
          trioIfDone +
          '</b>.' +
          rxNote;
      }
    }
    if (title) title.innerHTML = t;
    if (val) {
      val.classList.remove('is-bonus');
      if (P.rxQty && P.n > 0) {
        val.innerHTML =
          (v ? '<span>' + v + '</span>' : '') +
          '<span class="cd_prog__rxtag">+' +
          P.rxQty +
          ' Rx</span>';
      } else {
        val.textContent = v;
      }
    }
    if (sub) sub.innerHTML = su;
  }

  function paintStack(P) {
    var zone = qs('[data-cd-stack-zone]', state.root);
    var lines = qs('[data-cd-lines]', state.root);
    var foot = qs('[data-cd-stack-foot]', state.root);
    if (!zone || !lines) return;

    var collapsible = pairCount() >= 2;
    var collapsed = collapsible && !state.stackOpen;
    lines.hidden = collapsed;
    lines.classList.toggle('is-collapsed', collapsed);

    if (!collapsible) {
      zone.innerHTML = '';
      if (foot) foot.innerHTML = '';
      return;
    }

    if (!collapsed) {
      var count = pairCount();
      zone.innerHTML =
        '<div class="cd_stack is-open" data-cd-stack-toggle role="button" tabindex="0" aria-expanded="true"><div class="cd_stack__row">' +
        '<div class="cd_stack__meta"><b>' +
        count +
        ' pair' +
        (count === 1 ? '' : 's') +
        ' in your cart</b><span>Tap to collapse</span></div>' +
        '<div class="cd_stack__chev">Hide ' +
        CHEV +
        '</div></div></div>';
      if (foot) {
        foot.innerHTML =
          '<div class="cd_stackfoot"><button type="button" data-cd-stack-toggle>Hide items ' + CHEV + '</button></div>';
      }
      return;
    }
    if (foot) foot.innerHTML = '';

    var thumbN = 0;
    var thumbs = '';
    var thumbOrder = items()
      .map(function (c, i) {
        return { c: c, i: i };
      })
      .sort(function (a, b) {
        return stackCategoryRank(a.c) - stackCategoryRank(b.c) || a.i - b.i;
      })
      .map(function (x) {
        return x.c;
      });
    var THUMB_MAX = 5;
    var totalUnits = thumbOrder.reduce(function (s, c) {
      return s + (c.qty || 0);
    }, 0);
    /* Cap at 5 slots total — leave room for a "+N" badge as the 5th slot
       when there's overflow, instead of always filling all 5-6 with images. */
    var imageLimit = totalUnits > THUMB_MAX ? THUMB_MAX - 1 : THUMB_MAX;
    thumbOrder.forEach(function (c) {
      for (var q = 0; q < c.qty && thumbN < imageLimit; q++) {
        var cls = '';
        if (c.kind === 'pair') {
          var u = pairUnit(c);
          cls = !u ? '' : u.tag === 'free' ? ' is-free' : '';
        } else if (c.kind === 'readers') {
          cls = ' is-single';
        } else if (c.kind === 'rx') cls = ' is-rx';
        else if (c.kind === 'mystery') cls = ' is-myst';
        else if (c.kind === 'gift') cls = ' is-free';
        thumbs +=
          '<div class="cd_stack__t' +
          cls +
          '">' +
          (c.img ? '<img src="' + esc(c.img) + '" alt="">' : '') +
          '</div>';
        thumbN++;
      }
    });
    var hiddenUnits = totalUnits - thumbN;
    if (hiddenUnits > 0) {
      thumbs += '<div class="cd_stack__t cd_stack__t--more">+' + hiddenUnits + '</div>';
    }
    var pairs = pairCount();
    var addons = sumQty('addon');
    /* v7: short summary — "8 pairs · 1 Rx", then "4 free" — instead of a three-line list */
    var head = [];
    if (P.n) head.push(P.n + ' pair' + (P.n === 1 ? '' : 's'));
    if (P.rxQty) head.push(P.rxQty + ' Rx');
    if (P.readersQty) head.push(P.readersQty + ' Readers');
    if (P.mysteryQty) head.push('<span class="cd_stack__mword">' + P.mysteryQty + ' Mystery</span>');
    var subBits = [];
    if (P.freeCount) subBits.push(P.freeCount + ' free');
    if (P.giftQty) subBits.push('free gift');
    if (addons) subBits.push(addons + ' add-on' + (addons === 1 ? '' : 's'));

    zone.innerHTML =
      '<div class="cd_stack" data-cd-stack-toggle role="button" tabindex="0" aria-expanded="false"><div class="cd_stack__row">' +
      '<div class="cd_stack__thumbs">' +
      thumbs +
      '</div>' +
      '<div class="cd_stack__meta"><b>' +
      /* head holds counts and fixed words only, plus the violet Mystery span */
      (head.length ? head.join(' · ') : pairs + ' pair' + (pairs === 1 ? '' : 's')) +
      '</b><span>' +
      esc(subBits.length ? subBits.join(' · ') : 'Tap to edit') +
      '</span></div>' +
      '<div class="cd_stack__chev">Edit ' +
      CHEV +
      '</div></div></div>';
  }

  function qtyHTML(c) {
    if (c.hideQty) return '';
    return (
      '<div class="cd_qty">' +
      '<button type="button" data-cd-qty="-1" data-id="' +
      esc(c.key || c.variantId) +
      '" data-quantity="' +
      c.qty +
      '" aria-label="Decrease quantity">&minus;</button>' +
      '<i>' +
      c.qty +
      '</i>' +
      '<button type="button" data-cd-qty="1" data-id="' +
      esc(c.key || c.variantId) +
      '" data-quantity="' +
      c.qty +
      '" aria-label="Increase quantity">+</button></div>'
    );
  }

  function lineRight(c, was, now, extraClass, free) {
    var cls = extraClass ? ' ' + extraClass : '';
    var showWas = was > now || (free && was > 0);
    var edit =
      c.editUrl
        ? '<a href="' + esc(c.editUrl) + '" class="cd_rm cd_edit">Edit</a>'
        : '';
    return (
      '<div class="cd_line__right">' +
      '<span class="cd_was">' +
      (showWas ? money(was) : '') +
      '</span>' +
      '<div class="cd_line__pay"><span class="cd_amt' +
      cls +
      '">' +
      (free ? 'FREE' : money(now)) +
      '</span>' +
      qtyHTML(c) +
      '</div>' +
      '<div class="cd_line__acts">' +
      edit +
      (c.hideQty
        ? ''
        : '<button type="button" class="cd_rm" data-cd-rm data-id="' + esc(c.key || c.variantId) + '">Remove</button>') +
      '</div>' +
      '</div>'
    );
  }

  function customerFrame(label) {
    var s = String(label || '').trim();
    if (!s) return '';
    if (s.indexOf('/') !== -1) return '';
    if (/^default title$/i.test(s)) return '';
    if (/^oph/i.test(s.replace(/[\s_-]/g, ''))) return '';
    return s;
  }

  function rxLineHTML(c) {
    var frame = customerFrame(c.frame) || customerFrame(frameForHandle(c && c.handle));
    var sub = frame ? esc(frame) + ' · Prescription' : 'Prescription';
    var lens = String(c.lensLabel || lensLabelFrom(c) || '').trim();
    var lensChip = lens
      ? '<span class="cd_chip cd_chip--lens">' + esc(lens) + '</span>'
      : '';
    return (
      '<div class="cd_line is-rx"><div class="cd_line__th">' +
      (c.img ? '<img src="' + esc(c.img) + '" alt="">' : '') +
      '</div>' +
      '<div class="cd_line__meta"><b>' +
      esc(c.title) +
      '</b><span class="cd_line__sub">' +
      sub +
      '</span>' +
      '<div class="cd_chips"><span class="cd_chip cd_chip--rx">30% off</span>' +
      lensChip +
      '</div></div>' +
      lineRight(c, c.lineOriginal, c.lineFinal, 'cd_amt--rx') +
      '</div>'
    );
  }

  function paintLines(P) {
    var el = qs('[data-cd-lines]', state.root);
    if (!el) return;
    var hideIds = (state.cfg.settings && state.cfg.settings.hideVariantIds) || '';
    var idx = 0;
    var rx = [];
    var nonRx = [];

    displayItems().forEach(function (c) {
      if (c.kind === 'rx') {
        rx.push(rxLineHTML(c));
        return;
      }
      if (c.kind === 'gift') {
        nonRx.push(
          '<div class="cd_line is-free is-gift" data-cd-line-key="' +
            esc(c.key) +
            '">' +
            '<div class="cd_line__th"><span class="cd_idx">0</span>' +
            (c.img ? '<img src="' + esc(c.img) + '" alt="">' : '') +
            '</div>' +
            '<div class="cd_line__meta"><b>' +
            esc(c.title) +
            '</b><span class="cd_line__sub cd_line__sub--plain">On us with your order</span>' +
            '<div class="cd_chips"><span class="cd_chip cd_chip--free">Free gift</span></div></div>' +
            lineRight(c, c.lineOriginal, 0, 'cd_amt--free', true) +
            '</div>'
        );
        return;
      }
      if (c.kind === 'mystery') {
        /* v11: violet card, no pair number and no struck price — it sits
           outside Buy 1, Get 2 Free. The style it was picked as is a chip. */
        var mVariant = mysteryVariantLabel(c);
        nonRx.push(
          '<div class="cd_line is-mystery"><div class="cd_line__th">' +
            (c.img ? '<img src="' + esc(c.img) + '" alt="">' : '') +
            '</div>' +
            '<div class="cd_line__meta"><b>' +
            esc(c.title || 'Mystery Pair') +
            '</b><span class="cd_line__sub cd_line__sub--plain">Not part of Buy 1, Get 2 Free · final sale</span>' +
            '<div class="cd_chips"><span class="cd_chip cd_chip--myst">Extra pair</span>' +
            (mVariant ? '<span class="cd_chip cd_chip--mvar">' + esc(mVariant) + '</span>' : '') +
            '</div></div>' +
            lineRight(c, c.lineFinal, c.lineFinal, 'cd_amt--myst') +
            '</div>'
        );
        return;
      }
      if (c.kind === 'addon') {
        nonRx.push(
          '<div class="cd_line"><div class="cd_line__th">' +
            (c.img ? '<img src="' + esc(c.img) + '" alt="">' : '') +
            '</div>' +
            '<div class="cd_line__meta"><b>' +
            esc(c.title) +
            '</b><span class="cd_line__sub">Accessory</span>' +
            '<div class="cd_chips"><span class="cd_chip cd_chip--paid">' +
            esc(c.frame || 'Add-on') +
            '</span></div></div>' +
            lineRight(c, c.lineOriginal, c.lineFinal) +
            '</div>'
        );
        return;
      }

      if (c.kind === 'readers') {
        var rNum = ++idx;
        var rApplied = appliedDiscounts(c);
        var rChip = rApplied.length
          ? rApplied
              .map(function (d) {
                var tag = tagFromDiscountTitle(d.title);
                if (tag === 'free' || tag === 'paid' || tag === 'bonus') tag = 'single';
                return chipHTML(tag, chipLabel(tag, d.title));
              })
              .join('')
          : chipHTML('single');
        var rHide = hideIds && String(hideIds).indexOf(String(c.productId)) !== -1;
        var rSub = rHide ? '' : readersSubHTML(c);
        nonRx.push(
          '<div class="cd_line is-single" data-cd-line-key="' +
            esc(c.key) +
            '">' +
            '<div class="cd_line__th"><span class="cd_idx">' +
            rNum +
            '</span>' +
            (c.img ? '<img src="' + esc(c.img) + '" alt="">' : '') +
            '</div>' +
            '<div class="cd_line__meta"><b>' +
            (c.url ? '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>' : esc(c.title)) +
            '</b><span class="cd_line__sub">' +
            rSub +
            '</span><div class="cd_chips">' +
            rChip +
            '</div></div>' +
            lineRight(c, c.lineOriginal, c.lineFinal) +
            '</div>'
        );
        return;
      }

      var u = pairUnit(c);
      var isFree = u.tag === 'free';
      /* Only downgrade when no trio has completed yet (P.n < 3) — P.filling
         stays true after a trio completes too (a new set may be filling),
         and that must not relabel the finished trio's free/paid pairs. */
      var isSingle = u.tag === 'single' || (!!P && P.n < 3 && !isFree);
      var num = ++idx;
      var applied = appliedDiscounts(c);
      var chip = applied.length
        ? applied
            .map(function (d) {
              var tag = tagFromDiscountTitle(d.title);
              /* 1–2 pair cart: B1G2F-named shop discounts still read as 30% off */
              if (P && P.n < 3 && (tag === 'free' || tag === 'paid')) tag = 'single';
              if (tag === 'bonus' || tag === 'paid') return chipHTML('paid');
              return chipHTML(tag, chipLabel(tag, d.title, c.qty));
            })
            .join('')
        : chipHTML(
            isFree ? 'free' : isSingle ? 'single' : 'paid',
            chipLabel(isFree ? 'free' : isSingle ? 'single' : 'paid', '', c.qty)
          );
      if (isZ87Pair(c)) {
        chip += '<span class="cd_chip cd_chip--z87">Z87+</span>';
      }
      var hideName = hideIds && String(hideIds).indexOf(String(c.productId)) !== -1;
      var sub = hideName ? '' : pairSubHTML(c);
      nonRx.push(
        '<div class="cd_line' +
          (isFree ? ' is-free' : '') +
          (isSingle ? ' is-single' : '') +
          '" data-cd-line-key="' +
          esc(c.key) +
          '">' +
          '<div class="cd_line__th"><span class="cd_idx">' +
          num +
          '</span>' +
          (c.img ? '<img src="' + esc(c.img) + '" alt="">' : '') +
          '</div>' +
          '<div class="cd_line__meta"><b>' +
          (c.url ? '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>' : esc(c.title)) +
          '</b><span class="cd_line__sub">' +
          sub +
          '</span><div class="cd_chips">' +
          chip +
          '</div></div>' +
          lineRight(
            c,
            c.lineOriginal,
            c.lineFinal,
            Number(c.lineFinal) <= 0 ? 'cd_amt--free' : '',
            Number(c.lineFinal) <= 0
          ) +
          '</div>'
      );
    });

    var html = '';
    if (rx.length) {
      html +=
        '<div class="cd_grouphead"><div class="cd_grouphead__icon" aria-hidden="true"><svg viewBox="0 0 24 24">' +
        RX_ICON +
        '</svg></div><b>Prescription</b><span>30% off · separate offer</span></div>' +
        rx.join('');
    }
    html = nonRx.join('') + html;
    el.innerHTML = html;
  }

  function shopAll() {
    var s = state.cfg.settings || {};
    return s.shopAll || '/collections/best-sellers';
  }

  function tabViewAll(tabIndex) {
    var tab = productTabs()[tabIndex] || {};
    if (tab.viewAll) return tab.viewAll;
    var byKey = {
      best: '/collections/best-sellers',
      men: '/collections/men',
      women: '/collections/women'
    };
    return byKey[tab.key] || shopAll();
  }

  function rxAll() {
    var rx = state.cfg.rx || {};
    return rx.viewAll || shopAll();
  }

  /* Only touch the DOM when a zone's markup actually changed, so repainting
     for an unrelated reason (e.g. switching addon tabs) doesn't rebuild the
     pair rail — which would replay the card pop-in animation, reload the
     images and reset the rail's scroll position. */
  function setZoneHTML(el, html) {
    if (el.__cdHtml === html) return;
    el.__cdHtml = html;
    el.innerHTML = html;
  }

  function paintOfferZone(P) {
    var el = qs('[data-cd-offer]', state.root);
    if (!el) return;
    var s = state.cfg.settings || {};
    var html = '';
    var tabKey = esc((productTabs()[state.activeTab] || {}).key || '');
    function upsellAttrs(type, tab) {
      return ' data-cd-upsell="' + type + '" data-cd-upsell-tab="' + (tab || '') + '"';
    }

    if (P.rxOnly) {
      var rxFrom = 6930;
      var rxProds = (state.cfg.rx && state.cfg.rx.products) || [];
      if (rxProds[0] && rxProds[0].price) {
        rxFrom = Math.round(Number(rxProds[0].price) * 0.7);
      }
      html =
        '<div class="cd_sect"' +
        upsellAttrs('rx_pair', 'rx') +
        '><div class="cd_sect__head"><h4>Add another Rx pair</h4>' +
        '<a href="' +
        esc(rxAll()) +
        '" data-cd-browse-all>All Rx frames</a></div>' +
        '<p class="cd_sect__lede">30% comes off every prescription pair. Lenses included, from ' +
        money(rxFrom) +
        ' a pair.</p>' +
        railHTML(rxProds, 'rx', 8) +
        '</div>' +
        '<div class="cd_rxnote">Shopping non-prescription too? Sunglasses run <b>' +
        esc(s.offerTitle || 'Buy 1, Get 2 Free') +
        '</b> &mdash; a separate offer that does not change your Rx pricing. ' +
        '<a href="' +
        esc(shopAll()) +
        '" data-cd-browse-all>Browse sunglasses &rarr;</a></div>';
      setZoneHTML(el, html);
      return;
    }

    if (P.n === 0) {
      html =
        '<div class="cd_sect"' +
        upsellAttrs('start_offer', tabKey) +
        '><div class="cd_sect__head"><h4>Start ' +
        esc(s.offerTitle || 'Buy 1, Get 2 Free') +
        '&trade;</h4>' +
        '<a href="' +
        esc(tabViewAll(state.activeTab)) +
        '" data-cd-browse-all>Browse all</a></div>' +
        '<p class="cd_sect__lede">Buy one pair, get the next two free. You only pay for your highest-priced pair.</p>' +
        '<div class="cd_empty_tabs" role="tablist">' +
        tabsHTML(state.activeTab, 'cd-tab') +
        '</div>' +
        tabRail(state.activeTab, 'empty', 8) +
        '</div>';
    } else if (P.filling) {
      var two = P.showFreePicker;
      html =
        '<div class="cd_sect" data-cd-nextpair-sect' +
        upsellAttrs(two ? 'free_pair' : 'next_pair', tabKey) +
        '><div class="cd_sect__head"><h4>' +
        (two ? 'Pick your free pair' : 'Add your next pair') +
        '</h4><a href="' +
        esc(tabViewAll(state.activeTab)) +
        '" data-cd-browse-all>Browse all</a></div>' +
        '<div class="cd_empty_tabs" role="tablist">' +
        tabsHTML(state.activeTab, 'cd-tab') +
        '</div>' +
        tabRail(state.activeTab, two ? 'free' : 'single', 8, true) +
        '</div>';
    } else if (P.complete && !P.rxQty) {
      /* Finished set(s): add-ons lead; quiet rail starts the next set below */
      html =
        '<div class="cd_sect" data-cd-nextpair-sect' +
        upsellAttrs('start_another_set', tabKey) +
        '><div class="cd_sect__head"><h4>Start another set</h4>' +
        '<a href="' +
        esc(tabViewAll(state.activeTab)) +
        '" data-cd-browse-all>Browse all</a></div>' +
        '<p class="cd_sect__lede">Your next pair is 30% off. Add three and you only pay for one.</p>' +
        '<div class="cd_empty_tabs" role="tablist">' +
        tabsHTML(state.activeTab, 'cd-tab') +
        '</div>' +
        tabRail(state.activeTab, 'single', 8, true) +
        '</div>';
    }
    setZoneHTML(el, html);
  }

  function mysteryVariantLabel(c) {
    var v = String((c && (c.variantTitle || c.lens)) || '').trim();
    if (!v) return '';
    if (/^default title$/i.test(v)) return '';
    if (c.title && v.toLowerCase() === String(c.title).toLowerCase()) return '';
    return v;
  }

  function extrasPane() {
    var m = state.cfg.mystery;
    if (!m) return '';
    var vid = state.mysteryVariantId || (m.variants[0] && m.variants[0].id);
    var inCart = items().some(function (c) {
      return c.kind === 'mystery' && String(c.variantId) === String(vid);
    });
    var options = (m.variants || [])
      .map(function (v) {
        return (
          '<option value="' +
          esc(v.id) +
          '"' +
          (String(v.id) === String(vid) ? ' selected' : '') +
          (v.available === false ? ' disabled' : '') +
          '>' +
          esc(v.title) +
          '</option>'
        );
      })
      .join('');
    return (
      '<div class="cd_mcard is-violet" data-cd-filled-mystery>' +
      '<div class="cd_arow"><div class="cd_arow__th">' +
      (m.img ? '<img src="' + esc(m.img) + '" alt="">' : '') +
      '</div>' +
      '<div class="cd_arow__meta"><b>' +
      esc(m.title) +
      '<span class="cd_vchip">Extra pair</span></b><span>' +
      'Random pair, polarized, final sale' +
      '</span>' +
      (options
        ? '<label class="cd_mpick"><select aria-label="Mystery Pair style" data-cd-mystery-select>' +
          options +
          '</select></label>'
        : '') +
      '</div>' +
      arowPriceHTML(m.price, m.compare) +
      '<button type="button" class="cd_arow__add' +
      (inCart ? ' is-done' : '') +
      '" data-cd-atc data-cd-mystery-add data-handle="' +
      esc(m.handle) +
      '" data-variant-id="' +
      esc(vid) +
      '"' +
      trackAttrs(m.title, m.price, 'Mystery') +
      '>' +
      '+' +
      '</button></div>' +
      '</div>'
    );
  }

  /* Add-on row price: sale price in gold with the compare-at price struck
     beside it when the variant has one, else just the price. */
  function arowPriceHTML(price, compare) {
    var sale = Number(compare) > Number(price);
    return (
      '<div class="cd_arow__price' +
      (sale ? ' is-sale' : '') +
      '"><b>' +
      money(price) +
      '</b>' +
      (sale ? '<s>' + money(compare) + '</s>' : '') +
      '</div>'
    );
  }

  /* ===== Add-on upsell rules =====
     Port of the old Liquid cart drawer's upsell logic (documented in
     config/cart-upsell-logic.json). Each Cases / Care / Straps row carries a
     single and a 3-pack SKU; these rules pick which one to offer, or hide
     the row. */
  var CASE_ELIGIBLE_TYPES = { Ophthalmic: 1, Prescription: 1, Sunglasses: 1, 'Blue Light': 1 };
  var ADDON_CASES = [
    'neven-signature-hard-case',
    '3-pack-signature-hard-case',
    'slim-hard-case',
    '3-pack-slim-hard-case',
    'quick-close-case',
    '3-pack-quick-close-case'
  ];
  var ADDON_SIGNATURE_CASES = ['neven-signature-hard-case', '3-pack-signature-hard-case'];
  var ADDON_SMALL_CASES = ['slim-hard-case', '3-pack-slim-hard-case', 'quick-close-case', '3-pack-quick-close-case'];
  var ADDON_CLEANING_KITS = [
    'cleaning-kit',
    'slim-cleaning-kit',
    'pen-style-cleaning-kit',
    '3-pack-cleaning-kit',
    '3-pack-slim-cleaning-kit',
    '3-pack-pen-style-cleaning-kits'
  ];
  /* Featured cleaning kit rotates every 48h through this base order */
  var ADDON_KIT_ROTATION = [
    ['cleaning-kit', '3-pack-cleaning-kit'],
    ['slim-cleaning-kit', '3-pack-slim-cleaning-kit'],
    ['pen-style-cleaning-kit', '3-pack-pen-style-cleaning-kits']
  ];
  var ADDON_WIRE_RETAINERS = ['wire-retainer', '3-pack-wire-retainer'];
  var ADDON_STRAPS = ['neven-signature-strap', '3-pack-signature-strap'];

  function isPackHandle(handle) {
    return String(handle || '').indexOf('3-pack') >= 0;
  }

  function addonCartState() {
    var s = {
      count: 0,
      allRx: true,
      largeCase: false,
      singleCase: false,
      packCase: false,
      kit: false,
      retainer: false,
      strap: false,
      handles: {}
    };
    var lines = items();
    lines.forEach(function (c) {
      var handle = c.handle || '';
      var tags = state.caseTags[handle] || {};
      s.handles[handle] = true;
      if (CASE_ELIGIBLE_TYPES[c.type]) {
        s.count += Number(c.qty) || 0;
        if (c.type === 'Ophthalmic') {
          if (String(c.variantTitle || '').indexOf('Prescription') < 0) s.allRx = false;
        } else if (c.type !== 'Prescription' && !tags.exempt) {
          s.allRx = false;
        }
      }
      if (tags.large) s.largeCase = true;
      if (ADDON_CASES.indexOf(handle) >= 0) {
        if (isPackHandle(handle)) s.packCase = true;
        else s.singleCase = true;
      }
      if (ADDON_CLEANING_KITS.indexOf(handle) >= 0) s.kit = true;
      if (ADDON_WIRE_RETAINERS.indexOf(handle) >= 0) s.retainer = true;
      if (ADDON_STRAPS.indexOf(handle) >= 0) s.strap = true;
    });
    if (!lines.length) {
      s.allRx = false;
      s.count = 1;
    }
    return s;
  }

  /* Hide rules for one SKU, minus the single-vs-3-pack size rule
     (addonSku applies that). `loose` (the "Also popular" rail) keeps the
     fit rules but drops the category-in-cart ones, so a carted Wire
     Retainer still leaves the Signature Strap on offer. */
  function addonSkuHidden(handle, s, loose) {
    if (!handle) return true;
    if (s.handles[handle] && !(loose && state.railAdded[handle])) return true;
    var pack = isPackHandle(handle);
    var isCase = ADDON_CASES.indexOf(handle) >= 0;
    /* Large frames only fit the Signature case; all-Rx carts already come
       with cases; otherwise Signature cases are held back. */
    if (s.largeCase) {
      if (ADDON_SMALL_CASES.indexOf(handle) >= 0) return true;
    } else if (s.allRx) {
      if (isCase) return true;
    } else if (ADDON_SIGNATURE_CASES.indexOf(handle) >= 0) {
      return true;
    }
    if (loose) return false;
    if (isCase) {
      if (s.packCase && pack) return true;
      if (s.singleCase && !pack) return true;
    }
    if (ADDON_CLEANING_KITS.indexOf(handle) >= 0 && s.kit) return true;
    if (ADDON_WIRE_RETAINERS.indexOf(handle) >= 0 || ADDON_STRAPS.indexOf(handle) >= 0) {
      if (s.retainer || s.strap) return true;
    }
    return false;
  }

  /* 1 eligible pair → single, 2+ → 3-pack. If that size is out of stock
     (null in the catalog), fall back to the other size. */
  function addonSku(item, s, loose) {
    var want = s.count > 1 ? item.pack : item.single;
    var other = s.count > 1 ? item.single : item.pack;
    var sku = want && want.variantId ? want : other && other.variantId ? other : null;
    if (!sku || addonSkuHidden(sku.handle, s, loose)) return null;
    return sku;
  }

  function kitRotationIndex(item) {
    var handles = [item.single && item.single.handle, item.pack && item.pack.handle];
    for (var i = 0; i < ADDON_KIT_ROTATION.length; i++) {
      if (handles.indexOf(ADDON_KIT_ROTATION[i][0]) >= 0 || handles.indexOf(ADDON_KIT_ROTATION[i][1]) >= 0) {
        var start = Math.floor(Date.now() / 1000 / 172800) % ADDON_KIT_ROTATION.length;
        return (i - start + ADDON_KIT_ROTATION.length) % ADDON_KIT_ROTATION.length;
      }
    }
    return -1;
  }

  /* Rows to offer: each item resolved to one SKU. Strict (Protect your
     pairs) offers at most one cleaning kit — the first available in the
     48h rotation; loose (Also popular) offers them all. */
  function addonPicks(list, loose) {
    var s = addonCartState();
    var picks = [];
    var kitAt = -1;
    var kitRot = 0;
    (list || []).forEach(function (item) {
      var sku = addonSku(item, s, loose);
      if (!sku) return;
      var pick = { item: item, sku: sku, done: !!s.handles[sku.handle] };
      var rot = !loose && ADDON_CLEANING_KITS.indexOf(sku.handle) >= 0 ? kitRotationIndex(item) : -1;
      if (rot < 0) {
        picks.push(pick);
      } else if (kitAt < 0) {
        kitAt = picks.length;
        kitRot = rot;
        picks.push(pick);
      } else if (rot < kitRot) {
        picks[kitAt] = pick;
        kitRot = rot;
      }
    });
    return picks;
  }

  /* v9 add-on block: one pick per category up front (Mystery Pair, a case,
     a retainer, a cleaning kit), an "Add all" button for the accessory
     picks, then an "Also popular" rail with everything else. Which SKU
     each row offers (single / 3-pack) follows the add-on upsell rules
     above. A pick drops off once its category is covered; the rail keeps
     the rest of the category (a carted retainer leaves the strap). */
  var PICK_CATS = ['cases', 'straps', 'care'];
  var ALSO_ORDER = [
    'neven-signature-strap',
    'neven-signature-hard-case',
    'quick-close-case',
    'pen-style-cleaning-kit',
    'slim-cleaning-kit',
    'slim-hard-case',
    'cleaning-kit',
    'wire-retainer'
  ];

  /* Every add-on in a group as a flat entry. Catalog items carry a single
     and an optional 3-pack; a tab fed by a collection just has products. */
  function addonEntries(group, loose) {
    if (group.items && group.items.length) {
      return addonPicks(group.items, loose).map(function (pick) {
        var item = pick.item;
        return {
          item: item,
          title: item.title,
          blurb: item.blurb,
          hot: item.hot,
          pack: isPackHandle(pick.sku.handle),
          sku: pick.sku,
          done: pick.done,
          handles: [item.single && item.single.handle, item.pack && item.pack.handle]
        };
      });
    }
    return (group.products || []).slice(0, 6).map(function (p) {
      return { title: p.title, blurb: p.blurb, hot: false, pack: false, sku: p, handles: [p.handle] };
    });
  }

  function entryInCart(entry, inCart) {
    return entry.handles.some(function (h) {
      return h && inCart[h];
    });
  }

  function addonGroups() {
    var inCart = handlesInCart();
    return ((state.cfg && state.cfg.addons) || [])
      .filter(function (g) {
        return !g.extras;
      })
      .map(function (g) {
        if (g.items && g.items.length) {
          /* Catalog group: the pick is the first SKU the strict rules allow;
             the rail is everything the loose rules allow, minus the pick */
          var pick = addonEntries(g, false)[0] || null;
          return {
            key: g.key,
            pick: pick,
            rail: addonEntries(g, true).filter(function (e) {
              return !pick || e.item !== pick.item;
            })
          };
        }
        var entries = addonEntries(g);
        var taken = entries.some(function (e) {
          return entryInCart(e, inCart);
        });
        /* Collection group: a carted card stays checked; the rest go once
           the category is in the cart */
        return {
          key: g.key,
          pick: taken ? null : entries[0] || null,
          rail: entries
            .slice(1)
            .map(function (e) {
              e.done = entryInCart(e, inCart);
              return e;
            })
            .filter(function (e) {
              return e.done || !taken;
            })
        };
      });
  }

  function mysteryInCart() {
    return items().some(function (c) {
      return c.kind === 'mystery';
    });
  }

  function addonPickRow(entry) {
    var sku = entry.sku;
    return (
      '<div class="cd_arow"><div class="cd_arow__th">' +
      (entry.pack ? '<span class="cd_arow__qty">3</span>' : '') +
      (sku.img ? '<img loading="lazy" src="' + esc(sku.img) + '" alt="">' : '') +
      '</div>' +
      '<div class="cd_arow__meta"><b>' +
      esc(entry.title) +
      (entry.hot ? '<span class="cd_hotflag">Top seller</span>' : '') +
      '</b>' +
      (entry.blurb ? '<span class="cd_arow__why">' + esc(entry.blurb) + '</span>' : '') +
      (entry.pack ? '<span class="cd_arow__match">3-pack</span>' : '') +
      '</div>' +
      arowPriceHTML(sku.price, sku.compare) +
      '<button type="button" class="cd_arow__add" aria-label="Add ' +
      esc(entry.title) +
      '" data-cd-atc data-variant-id="' +
      esc(sku.variantId) +
      '" data-handle="' +
      esc(sku.handle) +
      '"' +
      trackAttrs(entry.title, sku.price, 'Accessory') +
      '>+</button></div>'
    );
  }

  function addAllHTML(picks) {
    if (picks.length < 2) return '';
    var sum = picks.reduce(function (t, e) {
      return t + (Number(e.sku.price) || 0);
    }, 0);
    return (
      '<button type="button" class="cd_addall" data-cd-atc data-variant-id="' +
      esc(
        picks
          .map(function (e) {
            return e.sku.variantId;
          })
          .join(',')
      ) +
      '" data-handle="' +
      esc(
        picks
          .map(function (e) {
            return e.sku.handle;
          })
          .join(',')
      ) +
      '"' +
      trackAttrs('Add all add-ons', sum, 'Accessory') +
      '>Add ' +
      (picks.length === 3 ? 'all 3' : 'both') +
      ' <span>&middot; ' +
      money(sum) +
      (picks[0].pack ? ' &middot; 3-packs' : '') +
      '</span></button>'
    );
  }

  function alsoCardHTML(entry, done) {
    var sku = entry.sku;
    var compare = Number(sku.compare) || 0;
    return (
      '<div class="cd_empty_card cd_rail_card cd_acard">' +
      '<div class="cd_empty_card__name">' +
      esc(entry.title) +
      '</div><div class="cd_empty_card__sub">' +
      esc(entry.blurb || '') +
      '</div>' +
      '<div class="cd_empty_card__shot" aria-hidden="true">' +
      (entry.pack ? '<span class="cd_arow__qty">3</span>' : '') +
      (sku.img ? '<img loading="lazy" src="' + esc(sku.img) + '" alt="">' : '') +
      '</div>' +
      '<div class="cd_empty_card__foot"><div class="cd_empty_card__price">' +
      money(sku.price) +
      (entry.pack && compare > Number(sku.price) ? ' <s>' + money(compare) + '</s>' : '') +
      '</div>' +
      '<button type="button" class="cd_empty_card__add' +
      (done ? ' is-done' : '') +
      '" aria-label="Add ' +
      esc(entry.title) +
      '" data-cd-atc data-variant-id="' +
      esc(sku.variantId) +
      '" data-handle="' +
      esc(sku.handle) +
      '"' +
      trackAttrs(entry.title, sku.price, 'Accessory') +
      '>+</button></div></div>'
    );
  }

  function alsoRank(entry) {
    var i = ALSO_ORDER.indexOf(entry.handles[0]);
    return i < 0 ? ALSO_ORDER.length : i;
  }

  function paintAddons(P) {
    var el = qs('[data-cd-addons]', state.root);
    if (!el) return;
    var mystery = state.cfg.mystery;
    var n = pairCount();
    var groups = addonGroups();
    var eligible = addonCartState().count;
    if (!groups.length && !mystery) {
      setZoneHTML(el, '');
      return;
    }

    /* Picks: the first add-on of each category, in pick order */
    var pickGroups = groups.slice().sort(function (a, b) {
      var ia = PICK_CATS.indexOf(a.key);
      var ib = PICK_CATS.indexOf(b.key);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
    var picks = [];
    pickGroups.forEach(function (g) {
      if (g.pick) picks.push(g.pick);
    });
    /* v11: Mystery Pair on its own (violet), then the accessory picks and
       Add all together in one "Protect your pairs" group */
    var packHint = eligible === 3 ? '3-packs, one per pair' : '3-packs';
    var kitHint = picks.some(function (e) {
      return e.pack;
    })
      ? packHint
      : 'One of each';
    var kitHTML = picks.length
      ? '<div class="cd_kit"><div class="cd_kit__head"><b>Protect your pair' +
        (n === 1 ? '' : 's') +
        '</b><span>' +
        kitHint +
        '</span></div>' +
        picks.map(addonPickRow).join('') +
        addAllHTML(picks) +
        '</div>'
      : '';
    var pickHTML = (mystery && !mysteryInCart() ? extrasPane() : '') + kitHTML;

    /* Also popular: the rest of every category */
    var also = [];
    groups.forEach(function (g) {
      g.rail.forEach(function (e) {
        also.push({ entry: e, done: !!e.done });
      });
    });
    also.sort(function (a, b) {
      return alsoRank(a.entry) - alsoRank(b.entry);
    });
    var alsoNote = also.some(function (a) {
      return a.entry.pack;
    })
      ? packHint
      : also.length > 2
        ? 'Swipe for more'
        : '';
    var alsoHTML = also.length
      ? '<div class="cd_also__head"><b>Also popular</b><span>' +
        alsoNote +
        '</span></div>' +
        '<div class="cd_railwrap"><div class="cd_rail">' +
        also
          .map(function (a) {
            return alsoCardHTML(a.entry, a.done);
          })
          .join('') +
        '</div></div>'
      : '';

    var heading = (state.cfg.settings && state.cfg.settings.addonHeading) || 'Add to your order';
    setZoneHTML(
      el,
      '<div class="cd_addons" data-cd-upsell="addon" data-cd-upsell-tab="v9"><div class="cd_addons__head"><h4>' +
        esc(heading) +
        '</h4></div>' +
        (pickHTML ? '<div class="cd_picks">' + pickHTML + '</div>' : '') +
        alsoHTML +
        '</div>'
    );
  }

  function paintFooter(P) {
    var foot = state.foot;
    if (!foot) return;
    var s = state.cfg.settings || {};
    var ship = qs('[data-cd-ship]', foot);
    var nudge = qs('[data-cd-nudge]', foot);
    var ledger = qs('[data-cd-ledger]', foot);
    var totLine = qs('[data-cd-ledger-toggle]', foot);
    var tot = qs('[data-cd-tot]', foot);
    var per = qs('[data-cd-per-pair]', foot);
    var pill = qs('[data-cd-saved-pill]', foot);
    var note = qs('[data-cd-foot-note]', foot);
    var cta = qs('#cart_drawer_checkout_button', foot) || qs('[data-rx-checkout-gate]', foot);

    var pairs = P.n + P.mysteryQty + P.rxQty + (P.readersQty || 0);
    var gap = Math.max(0, (s.freeShip || 5000) - P.total);

    if (ship) {
      if (gap > 0) {
        ship.innerHTML =
          '<div class="cd_shipbar">' +
          SHIP_SVG +
          '<div class="cd_shipbar__copy"><b>Add <i>' +
          money(gap) +
          '</i> for free worldwide shipping</b>' +
          '<div class="cd_shipbar__track"><div class="cd_shipbar__fill" style="width:' +
          Math.min(100, Math.round((P.total / (s.freeShip || 5000)) * 100)) +
          '%"></div></div></div></div>';
      } else {
        ship.innerHTML = '';
      }
    }

    if (nudge) {
      nudge.classList.remove('cd_nudge--violet');
      if (P.rxOnly) {
        nudge.classList.add('is-hidden');
      } else if (P.filling) {
        var trioMoney = money(P.trioIfDone || P.trioPrice || listCents());
        nudge.innerHTML = P.showFreePicker
          ? 'Add ' +
            (P.n === 2 ? 'a 3rd pair' : 'pair ' + (P.n + 1)) +
            ' — your total <b>drops ' +
            money(P.dropsAt3) +
            '</b>'
          : 'Add 2 more pairs free — ' + (P.n === 1 ? '3 pairs' : 'your next 3') + ' for ' + trioMoney;
        nudge.classList.remove('is-hidden');
      } else {
        nudge.classList.add('is-hidden');
      }
    }

    if (ledger) {
      var rows = '';
      var discount = Math.max(0, Number(P.discount) || 0);
      var freeSaving = Math.max(0, Number(P.freeSaving) || 0);
      var singleSaving = Math.max(0, Number(P.singleSaving) || 0);
      var rxSaving = Math.max(0, Number(P.rxSaving) || 0);
      var singleCount = Math.max(0, Number(P.singleCount) || 0);
      var subtotalBase = Math.max(0, (Number(P.original) || 0) - (Number(P.extrasOriginal) || 0));
      rows +=
        '<div class="cd_sum"><span>Subtotal (' +
        pairs +
        ' pair' +
        (pairs === 1 ? '' : 's') +
        ')</span><span>' +
        money(subtotalBase) +
        '</span></div>';
      /* Show every saving that actually applies — a completed trio and a
         filling extra pair can both be true at once (e.g. 4-8 pairs), so
         these are independent checks, not an if/else chain. */
      if (freeSaving > 0) {
        rows +=
          '<div class="cd_sum cd_sum--save"><span>' +
          esc((s.offerTitle || 'Buy 1, Get 2 Free') + '™') +
          '</span><span>−' +
          money(freeSaving) +
          '</span></div>';
      }
      if (singleSaving > 0) {
        var nSingle = singleCount || 1;
        rows +=
          '<div class="cd_sum cd_sum--save"><span>' +
          esc('30% off (' + nSingle + ' pair' + (nSingle === 1 ? '' : 's') + ')') +
          '</span><span>−' +
          money(singleSaving) +
          '</span></div>';
      }
      if (freeSaving <= 0 && singleSaving <= 0 && discount > rxSaving && discount - rxSaving > 0) {
        rows +=
          '<div class="cd_sum cd_sum--save"><span>' +
          esc((s.offerTitle || 'Buy 1, Get 2 Free') + '™') +
          '</span><span>−' +
          money(discount - rxSaving) +
          '</span></div>';
      }
      /* Rx is always its own blue line — not folded into 30% / B1G2F */
      if (P.rxQty > 0 && rxSaving > 0) {
        rows +=
          '<div class="cd_sum cd_sum--rx"><span>' +
          esc('Prescription (' + P.rxQty + ' pair' + (P.rxQty === 1 ? '' : 's') + ', 30% off)') +
          '</span><span>−' +
          money(rxSaving) +
          '</span></div>';
      }
      if (P.giftQty > 0) {
        rows += '<div class="cd_sum cd_sum--gift"><span>Free gift</span><span>' + money(0) + '</span></div>';
      }
      /* Footer-only: fold Mystery Pair cost into the same "Add-ons" row
         (still just one line, same label) — the progress rail up top
         keeps Mystery out of its own numbers. */
      var addonCost = Math.max(0, Number(P.addonCost) || 0) + Math.max(0, Number(P.mysteryCost) || 0);
      if (addonCost > 0) {
        rows +=
          '<div class="cd_sum"><span>Add-ons</span><span>+' +
          money(addonCost) +
          '</span></div>';
      }
      ledger.innerHTML = rows;
      ledger.hidden = !state.ledgerOpen;
      ledger.classList.toggle('is-hidden', !state.ledgerOpen);
    }
    if (totLine) {
      totLine.classList.toggle('is-open', state.ledgerOpen);
      totLine.hidden = !s.showDiscounts;
    }
    if (tot) tot.textContent = money(P.total);
    if (per) {
      per.textContent = P.rxQty || !P.glassesQty ? '' : money(P.perPair) + ' per pair';
    }
    if (pill) pill.textContent = P.discount > 0 ? 'saved ' + money(P.discount) : '';
    if (cta) {
      cta.textContent = 'Checkout';
      var href = foot.getAttribute('data-checkout-href');
      if (href) cta.setAttribute('href', href);
    }
    if (note) note.innerHTML = trustLine(gap > 0 ? 'Free worldwide shipping on $50+' : 'Free worldwide shipping');
  }

  /* Shipping / returns / guarantee on the first row, reviews on the second —
     the only trust copy in the drawer, under the Checkout button. */
  function trustLine(ship) {
    var s = state.cfg.settings || {};
    var reviews = String(s.reviewsStats || '').split('·')[0].trim();
    var dot = '<i class="cd_foot_note__dot">|</i>';
    return (
      '<span class="cd_foot_note__row"><a class="cd_foot_note__nw" href="' +
      esc(s.shippingUrl || '/policies/shipping-policy') +
      '">' +
      esc(ship) +
      '</a>' +
      dot +
      '<a class="cd_foot_note__nw" href="' +
      esc(s.returnsUrl || '#') +
      '"' +
      (/^https?:/.test(s.returnsUrl || '') ? ' target="_blank" rel="noopener"' : '') +
      '>Free returns &amp; exchanges</a>' +
      dot +
      '<a class="cd_foot_note__nw cd_foot_note__everlast" href="' +
      esc(s.everlastUrl || '/pages/everlastguarantee') +
      '">Everlast Guarantee&trade;</a></span>' +
      (reviews
        ? '<span class="cd_foot_note__row"><span class="cd_foot_note__stars" aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;</span> <b>' +
          esc(reviews) +
          '</b></span>'
        : '')
    );
  }

  function bindRailDrag(root) {
    if (!root) return;
    root.querySelectorAll('.cd_rail').forEach(function (rail) {
      if (rail.__cdDragBound) return;
      rail.__cdDragBound = true;
      var startX = 0;
      var startY = 0;
      var startLeft = 0;
      var dragging = false;
      var moved = false;
      var axis = null; /* 'x' once a horizontal drag is confirmed, 'y' once we hand off to page scroll */
      var pointerId = null;
      rail.addEventListener('pointerdown', function (e) {
        /* Touch/pen get pure native scrolling — .cd_rail is
           touch-action: pan-x pan-y, so the browser's own compositor
           handles both axes (smooth, no main-thread jank, no dead
           zones, and it already suppresses the click after a scroll
           gesture). This JS drag-to-scroll is only for mouse users,
           who don't get a native click-and-drag gesture on an
           overflow:auto element. */
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true;
        moved = false;
        axis = null;
        pointerId = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
        startLeft = rail.scrollLeft;
      });
      rail.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (!axis) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (axis === 'x') {
            moved = true;
            rail.classList.add('is-dragging');
            try {
              rail.setPointerCapture(pointerId);
            } catch (err) {}
          } else {
            /* Vertical gesture — let the browser scroll the cart drawer. */
            dragging = false;
            return;
          }
        }
        if (axis === 'x') {
          e.preventDefault();
          rail.scrollLeft = startLeft - dx;
        }
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        rail.classList.remove('is-dragging');
        if (moved) rail.dataset.cdDidDrag = '1';
      }
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      rail.addEventListener(
        'click',
        function (e) {
          if (rail.dataset.cdDidDrag === '1') {
            e.preventDefault();
            e.stopPropagation();
            rail.dataset.cdDidDrag = '0';
          }
        },
        true
      );
    });
  }

  function paint() {
    if (!state.root || !state.cfg) return;
    var P = pricing();
    paintProgress(P);
    paintLines(P);
    paintStack(P);
    paintOfferZone(P);
    paintAddons(P);
    paintFooter(P);

    bindRailDrag(state.root);

    var prog = qs('[data-cd-prog]', state.root);
    var stack = qs('[data-cd-stack-zone]', state.root);
    var lines = qs('[data-cd-lines]', state.root);
    var stackFoot = qs('[data-cd-stack-foot]', state.root);
    var offer = qs('[data-cd-offer]', state.root);
    var addons = qs('[data-cd-addons]', state.root);
    if (prog) prog.style.order = 0;
    if (stack) stack.style.order = 1;
    if (lines) lines.style.order = 2;
    if (stackFoot) stackFoot.style.order = 2;
    var noPairOffer = P.complete;
    if (offer) offer.style.order = noPairOffer ? 4 : 3;
    if (addons) addons.style.order = noPairOffer ? 3 : 4;

    checkB1g2fProgress();
    if (window.cdTrack && window.cdTrack.observeUpsells) window.cdTrack.observeUpsells(state.root);
  }

  function onClick(e) {
    var tog = e.target.closest('[data-cd-ledger-toggle]');
    if (tog) {
      state.ledgerOpen = !state.ledgerOpen;
      paint();
      return;
    }
    var tab = e.target.closest('[data-cd-tab]');
    if (tab) {
      state.activeTab = Number(tab.getAttribute('data-cd-tab')) || 0;
      paint();
      return;
    }
    var stackBtn = e.target.closest('[data-cd-stack-toggle]');
    if (stackBtn) {
      e.preventDefault();
      state.stackOpen = !state.stackOpen;
      paint();
      return;
    }
    var myst = e.target.closest('[data-cd-mystery-variant]');
    if (myst && !myst.disabled) {
      state.mysteryVariantId = myst.getAttribute('data-cd-mystery-variant');
      try {
        sessionStorage.setItem('cd_mystery_vid', String(state.mysteryVariantId));
      } catch (err) {}
      paint();
      return;
    }
    var atc = e.target.closest('[data-cd-atc]');
    if (!atc) {
      /* Tapping anywhere on a rail card adds it — same as the + button.
         Rail cards have no product-page link. */
      var atcCard = e.target.closest('.cd_rail .cd_empty_card');
      if (atcCard && !e.target.closest('a')) {
        atc = atcCard.querySelector('[data-cd-atc]');
      }
    }
    if (atc) {
      e.preventDefault();
      addToCart(atc);
      return;
    }
    var qty = e.target.closest('[data-cd-qty]');
    if (qty) {
      e.preventDefault();
      bumpLine(qty.getAttribute('data-id'), Number(qty.getAttribute('data-cd-qty')));
      return;
    }
    var rm = e.target.closest('[data-cd-rm]');
    if (rm) {
      e.preventDefault();
      changeLine(rm.getAttribute('data-id'), 0);
    }
  }

  function onKey(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var stackBtn = e.target.closest('[data-cd-stack-toggle]');
    if (!stackBtn) return;
    e.preventDefault();
    state.stackOpen = !state.stackOpen;
    paint();
  }

  function onChange(e) {
    var sel = e.target.closest('[data-cd-mystery-select]');
    if (!sel) return;
    state.mysteryVariantId = sel.value;
    try {
      sessionStorage.setItem('cd_mystery_vid', String(state.mysteryVariantId));
    } catch (err) {}
    paint();
  }

  function bindSection(section) {
    if (!section) return;
    if (state.boundSection === section) return;
    if (state.boundSection) {
      state.boundSection.removeEventListener('click', onClick);
      state.boundSection.removeEventListener('keydown', onKey);
      state.boundSection.removeEventListener('change', onChange);
    }
    section.addEventListener('click', onClick);
    section.addEventListener('keydown', onKey);
    section.addEventListener('change', onChange);
    state.boundSection = section;
  }

  function mount(section) {
    if (!section) return;
    bindSection(section);
    var root = section.querySelector('[data-cd-filled-state]');
    if (!root) return;
    var node = root.querySelector('[data-cd-filled-config]');
    if (!node) return;
    var raw = node.textContent;
    var cfg;
    try {
      cfg = JSON.parse(raw);
    } catch (err) {
      return;
    }
    state.cfg = cfg;
    state.cfgRaw = raw;
    state.root = root;
    state.section = section;
    state.foot = section.querySelector('[data-cd-filled-foot]');
    ((cfg.cart && cfg.cart.items) || []).forEach(function (c) {
      if (!c.handle) return;
      if (c.kind === 'gift') state.giftHandles[c.handle] = true;
      if (c.hideQty) state.hideQtyHandles[c.handle] = true;
      state.caseTags[c.handle] = { exempt: !!c.caseExemptFrame, large: !!c.largeCase };
    });
    try {
      /* Keep stackOpen in memory across remounts (in-drawer qty/ATC).
         Drawer open calls onOpen() to force collapse. */
      if (!state.mysteryVariantId) {
        state.mysteryVariantId = sessionStorage.getItem('cd_mystery_vid');
      }
    } catch (err) {}
    var mysteryVars = (cfg.mystery && cfg.mystery.variants) || [];
    var vidOk = mysteryVars.some(function (v) {
      return String(v.id) === String(state.mysteryVariantId);
    });
    if (!vidOk) {
      var cartMystery = ((cfg.cart && cfg.cart.items) || []).filter(function (c) {
        return c.kind === 'mystery';
      });
      var last = cartMystery[cartMystery.length - 1];
      state.mysteryVariantId = (last && last.variantId) || (mysteryVars[0] && mysteryVars[0].id) || null;
    }
    paint();
    refreshCart();
  }

  /* Call before mount() on drawer open — always start collapsed. Doesn't
     paint itself: mount() already ends with one paint(), so resetting the
     flag first lets that single paint reflect the collapsed state instead
     of doing a second full repaint right after. */
  function resetStackOnOpen() {
    state.stackOpen = false;
  }

  /* Kept for API compatibility — same effect as resetStackOnOpen(), but
     paints immediately (for a caller that isn't about to mount() anyway). */
  function onOpen() {
    resetStackOnOpen();
    if (state.root) paint();
  }

  window.CDFilled = {
    mount: mount,
    paint: paint,
    refresh: refreshCart,
    syncCart: syncCart,
    onOpen: onOpen,
    resetStackOnOpen: resetStackOnOpen,
    analyticsContext: analyticsContext
  };
})(window);
